import { INode } from 'common/interfaces/hierarchy-entities';
import { groupBy } from 'es-toolkit/compat';

type RefObject = { objectid: string; name: string; nodeid: string };

type SelectOption =
  | { label: string; value: string }
  | { type: 'Heading'; label: string };

// Groups the covariance matrices by their folder and puts the folder name above each group.
export const covarianceMatrixOptions = (matrices: RefObject[], folders: INode[]): SelectOption[] => {
  const folderNameByNodeId = new Map(folders.map((folder) => [folder.nodeid, folder.name]));
  const byFolder = groupBy(matrices, (matrix) => folderNameByNodeId.get(matrix.nodeid) ?? '');

  return Object.keys(byFolder)
    .sort()
    .flatMap((folderName) => {
      const heading: SelectOption[] = folderName ? [{ type: 'Heading', label: folderName }] : [];
      const rows = byFolder[folderName].map((matrix) => ({ label: matrix.name, value: matrix.objectid }));

      return [...heading, ...rows];
    });
};
